import { Box, Button, useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { adminActionService } from "../../services";
import { ConfirmModal } from "../../modals/confirm-modal.modal";

export const DemoTenantTab = () => {

    const confirmModal = useDisclosure();
    const [isLoading, setIsLoading] = useState(false);

    const clearDemoTenantData = async () => {
        try {
            setIsLoading(true);
            await adminActionService.clearDemoTenantData();
        } catch (error) { } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box>
            <Button isLoading={isLoading} colorScheme="danger" onClick={confirmModal.onOpen}>Clear Demo Tenant Data</Button>
            <ConfirmModal
                onConfirm={clearDemoTenantData}
                onCancel={confirmModal.onClose}
                message={"Are you sure you want to clear this data?"}
                isOpen={confirmModal.isOpen}
                onClose={confirmModal.onClose}
            />
        </Box>
    )
};